var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBgBenefits = function SvgBgBenefits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 297,
    height: 272
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg-benefits_svg__a",
    cx: "10.291%",
    cy: "2.027%",
    r: "116.133%",
    fx: "10.291%",
    fy: "2.027%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8658EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6831E5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#7142EB",
    d: "M246.51 219.762c27.206-7.29 43.352-35.255 36.062-62.462s-35.255-43.353-62.462-36.062-43.353 35.254-36.063 62.462 35.255 43.352 62.462 36.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bg-benefits_svg__a)",
    fillRule: "nonzero",
    d: "M21.5 42.5c11.598 0 21-9.402 21-21s-9.402-21-21-21-21 9.402-21 21 9.402 21 21 21z",
    transform: "rotate(-15 247.936 32.149)"
  }))));
};
export { SvgBgBenefits as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOTciIGhlaWdodD0iMjcyIiB2aWV3Qm94PSIwIDAgMjk3IDI3MiI+CiAgICA8ZGVmcz4KICAgICAgICA8cmFkaWFsR3JhZGllbnQgaWQ9InByZWZpeF9fYSIgY3g9IjEwLjI5MSUiIGN5PSIyLjAyNyUiIHI9IjExNi4xMzMlIiBmeD0iMTAuMjkxJSIgZnk9IjIuMDI3JSI+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiM4NjU4RUMiLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjNjgzMUU1Ii8+CiAgICAgICAgPC9yYWRpYWxHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjNzE0MkVCIiBkPSJNMTk4IDIxM2MyOC4xNjcgMCA1MS0yMi44MzMgNTEtNTFzLTIyLjgzMy01MS01MS01MS01MSAyMi44MzMtNTEgNTEgMjIuODMzIDUxIDUxIDUxeiIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1IDI0Ny45MzYgMzIuMTQ5KSIvPgogICAgICAgIDxwYXRoIGZpbGw9InVybCgjcHJlZml4X19hKSIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMjEuNSA0Mi41YzExLjU5OCAwIDIxLTkuNDAyIDIxLTIxcy05LjQwMi0yMS0yMS0yMS0yMSA5LjQwMi0yMSAyMSA5LjQwMiAyMSAyMSAyMXoiIHRyYW5zZm9ybT0icm90YXRlKC0xNSAyNDcuOTM2IDMyLjE0OSkiLz4KICAgIDwvZz4KPC9zdmc+Cg==";